module.exports = __webpack_public_path__ + "static/DHCM0-163708de6aea935dab550c82443468d5.png";